import api from "api"

export async function loadHouseholdBenefits(store, household_id) {
  const benefits = await api.get(`households/${household_id}/benefits`)
  await store.update(state => {
    state.householdBenefitIds[household_id] = benefits.map(
      benefit => benefit.id
    )

    benefits.forEach(benefit => {
      state.benefits[benefit.id] = benefit
    })
  })
}

export async function loadBenefit(store, benefit_id) {
  const benefit = await api.get(`benefits/${benefit_id}`)
  await store.update(state => {
    state.benefits[benefit.id] = benefit
  })
}

export async function addBenefit(store, { household_id, ...benefitDetails }) {
  const benefit = await api.post(
    `households/${household_id}/benefits`,
    undefined,
    benefitDetails
  )
  const household = await store.actions.loadHousehold(household_id)

  await store.update(state => {
    if (state.householdBenefitIds && state.householdBenefitIds[household_id]) {
      state.householdBenefitIds[household_id].push(benefit.id)
    }
    state.benefits[benefit.id] = benefit
    delete state.incomeBreakdowns[household_id]
  })

  if (!household.has_confirmed_benefits) {
    await store.actions.updateHousehold({
      id: household_id,
      has_confirmed_benefits: true
    })
  }
}

export async function updateBenefit(store, { id, ...benefitDetails }) {
  const benefit = await api.patch(`benefits/${id}`, undefined, benefitDetails)

  await store.update(state => {
    state.benefits[benefit.id] = benefit
    delete state.incomeBreakdowns[benefit.household_id]
  })
}

export async function deleteBenefit(store, { household_id, id }) {
  await api.delete(`benefits/${id}`)
  await store.update(state => {
    state.householdBenefitIds[household_id].splice(
      state.householdBenefitIds[household_id].findIndex(
        benefitId => benefitId === id
      ),
      1
    )
    delete state.incomeBreakdowns[household_id]
  })
}
